export const FETCH_PATH_REQUEST = 'FETCH_PATH_REQUEST'
export const FETCH_PATH_SUCCESS = 'FETCH_PATH_SUCCESS'
export const FETCH_PATH_FAILURE = 'FETCH_PATH_FAILURE'